import { RouteLocationNormalized } from "vue-router";

const BeforeEach = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
): void => {
  if (from.meta.bodyClass) {
    const fromClassString = from.meta.bodyClass as string;
    RemoveClass(fromClassString);
  }
  if (to.meta.bodyClass) {
    const toClassString = to.meta.bodyClass as string;
    AddClass(toClassString);
  }
};

const AddClass = (classString: string) => {
  const classList = classString.split(" ");

  for (const name of classList) {
    if (!document.body.classList.contains(name))
      document.body.classList.add(name);
  }
};

const RemoveClass = (classString: string) => {
  const classList = classString.split(" ");

  for (const name of classList) {
    if (document.body.classList.contains(name))
      document.body.classList.remove(name);
  }
};

export default {
  BeforeEach,
};
